import { calculatorChart, getNumber } from "./simulation_chart";
import Decimal from "decimal.js";

$(function () {
  $(".simulation_tabs li").on("click", function () {
    $(this).addClass("cur").siblings().removeClass("cur");
    $(this)
      .parent()
      .next()
      .children()
      .eq($(this).index())
      .removeClass("hidden")
      .siblings()
      .addClass("hidden");
    calculatorChart(getDatas());
  });

  // When the slide changes in real time, the data displayed on the page changes in real time
  $(".calculator_slide_box input[type=range]").on(
    "input propertychange",
    function () {
      let calSlide = $(this).parents(".calculator_slide_box");
      //初期投資額 输入框需输入后才可以画图
      calSlide.hasClass("initial_amount") ? calSlide.attr("data-clock", 1) : "";
      calSlide.find(".error_text").addClass("hidden");
      $(this).attr("step", $(this).attr("data-step-attr"));
      let attrMin = Number($(this).attr("data-min-attr"));
      let val = Number($(this).val());
      $(this)
        .next()
        .css(
          "width",
          (($(this).val() - $(this).attr("min")) /
            ($(this).attr("max") - $(this).attr("min"))) *
            100 +
            "%"
        );
      if (val <= attrMin) {
        val = attrMin;
        $(this).attr("min", $(this).attr("data-min-attr"));
      } else {
        // 目標金額 & 想定利回り（年率）step 及 min 会变动，数值修正
        if (
          $(this).parents(".calculator_slide_box").hasClass("target_amount") ||
          $(this).parents(".calculator_slide_box").hasClass("annual_rate")
        ) {
          if ((val - attrMin) % Number($(this).attr("data-step-attr")) == 0) {
            val = val - attrMin;
          }
        }
        $(this).attr("min", $(this).attr("data-min-real"));
      }
      calSlide
        .find(".import_input input")
        .val(toThousands(val))
        .attr("data-value", val);
      $(this).val(val);
      //初期投資額 输入框需输入为0时 触发画图
      calSlide.hasClass("initial_amount") && val == 0
        ? $(this).trigger("change")
        : "";
    }
  );

  let curCompositionstartVal = "";
  let useCurRecordInputValFlg = false;
  // 日文或中文输入法会触发此事件
  $(".calculator_slide_box").on(
    "compositionstart",
    ".import_input input",
    function () {
      if ($("main").find(".simulation_sp").length > 0) {
        useCurRecordInputValFlg = true;
      }
    }
  );

  // input propertychange
  // input not support e.key
  // keyup iphone safri 1->①
  // When the input changes in real time, the data displayed on the page changes in real time
  $(".calculator_slide_box .import_input input").on(
    "input propertychange",
    function () {
      let val = $(this).val();
      if (
        useCurRecordInputValFlg &&
        curCompositionstartVal != "" &&
        curCompositionstartVal.length < val.length
      )
        val = curCompositionstartVal;

      let maxlength = parseInt($(this).attr("maxlength"));
      // 全角小键盘可一直输入
      if (val.length > maxlength) val = val.substr(0, maxlength);

      let calSlide = $(this).parents(".calculator_slide_box");
      //初期投資額 输入框需输入后才可以画图
      calSlide.hasClass("initial_amount") ? calSlide.attr("data-clock", 1) : "";
      maxlength = parseInt($(this).attr("maxlength"));

      // 毎月の積み立て額 & 毎月の取り崩し額 & 想定利回り（年率） 允许输入小数
      let floatFlag =
        calSlide.hasClass("reserve_mount") ||
        calSlide.hasClass("withdrawal_amount") ||
        calSlide.hasClass("annual_rate")
          ? true
          : false;
      if (floatFlag && val.indexOf(".") != -1) {
        val = val.indexOf("..") != -1 ? val.replace("..", ".") : val;
        let arr = val.split(".");
        if (arr[1] == "") {
          $(this).val(val);
          return;
        }
      }

      let arr = inputValToThousand(val, maxlength, 0, true, floatFlag, false);

      // 目標金額 & 想定利回り（年率）step 及 min 会变动
      let rangeItem = calSlide.find(".slide_box input[type=range]");
      rangeItem.attr("step", rangeItem.attr("data-step-real"));
      rangeItem.attr("min", rangeItem.attr("data-min-attr"));

      //允许输入小数的输入框数据 只允许输入一位小数 即截取一位小数
      let decimalNum = floatFlag ? 1 : 0;
      let inVal = decimalNum
        ? subStringNum(Number(arr[0]), decimalNum)
        : Number(arr[0]);
      let rangeVal = inVal;
      $(this).attr("data-value", rangeVal);
      if (
        rangeVal <= Number(rangeItem.attr("data-max-attr")) &&
        rangeVal >= Number(rangeItem.attr("data-min-attr"))
      ) {
        calSlide.find(".error_text").addClass("hidden");

        rangeItem.val(rangeVal);
        $(this).val(toThousands(inVal, decimalNum));
        rangeItem
          .next()
          .css(
            "width",
            ((rangeItem.val() - rangeItem.attr("min")) /
              (rangeItem.attr("max") - rangeItem.attr("min"))) *
              100 +
              "%"
          );

        // 输入框需要触发change事件，slide 不用触发
        $(this).trigger("change");
      } else {
        // 输入有误提示语追加
        if (rangeVal == 0) $(this).val(inVal);
        $(this).val(toThousands(inVal, decimalNum));
        calSlide.find(".error_text").removeClass("hidden");
        calSlide.parents(".simulation_box").find(".content_text").text("-");
        calculatorChart([], 0);
      }
    }
  );

  // mac的safari keydown事件在input监听后面
  // iphone safari keydown事件在input监听前面
  $(".calculator_slide_box").on("keydown", ".import_input input", function (e) {
    if (e.key.length == 1) {
      curCompositionstartVal = $(this).val() + e.key;
    }
  });

  $(".calculator_slide_box").on("focus", ".import_input input", function () {
    curCompositionstartVal = $(this).val();
  });

  $(".calculator_slide_box").on("keyup", ".import_input input", function (e) {
    if (e.key == "Enter") {
      $(this).blur();
    }
  });

  $(".calculator_slide_box").on("paste", ".import_input input", function () {
    $(this).trigger("keyup");
  });

  // slide or input 输入框 数值变化时，更新chart图
  $(
    ".calculator_slide_box input[type=range], .calculator_slide_box .import_input input"
  ).on("change", function () {
    let calSlide = $(
      ".simulation_content:not(.hidden) .simulation_box:not(.hidden)"
    );
    // getDatas() 数据有period数据,无需再传period
    if (
      calSlide.find(".initial_amount").length > 0 &&
      calSlide.find(".initial_amount").attr("data-clock") == 0
    ) {
      calculatorChart([], 0);
    } else {
      calculatorChart(getDatas());
    }
  });

  $(".calculator_slide_box input[type=range]").each(function () {
    $(this).trigger("input");
  });

  $(".withdraw_tab_btn").on("click", function () {
    let idx = $(this)
      .parents(".simulation_content")
      .find(".simulation_box")
      .index($(this).parents(".simulation_box"));
    $(".total_simulation_tabs li:last-child").trigger("click");
    $(".total_simulation_tabs")
      .next()
      .find(".simulation_tabs li:nth-child(" + (idx + 1) + ")")
      .trigger("click");
    let component = $(
      ".simulation_content:not(.hidden) .simulation_box:not(.hidden)"
    );
    let changeValue = Math.round(
      Number(
        $(
          ".pageCon_simulation .simulation_content:first-child .simulation_box:nth-child(" +
            (idx + 1) +
            ") #content_text_1"
        ).attr("data-target-amount")
      ) / 10000
    );
    component
      .find(".assets_amount .import_input input")
      .val(changeValue)
      .attr("data-value", changeValue);
    component.find(".assets_amount .import_input input").trigger("input");
    calculatorChart(getDatas());
    $(window).scrollTop(0);
  });

  // tab 初始化显示
  $(".simulation_tabs li:first-child").trigger("click");
});

// 不四舍五入 保留 num 位小数
// 传参a是要截取的数值，可以是数字也可以是字符串，num是要截取的小数位数
function subStringNum(a, num) {
  let a_type = typeof a;
  let aArr;
  if (a_type == "number") {
    let aStr = a.toString();
    aArr = aStr.split(".");
  } else if (a_type == "string") {
    aArr = a.split(".");
  }

  if (aArr.length > 1) {
    a = aArr[0] + "." + aArr[1].substr(0, num);
  }
  return a;
}

// 函数选择
function getDatas() {
  let graph_datas = [];
  // 查找当前页面是積み立て 还是 取り崩す
  let target_page_id = $(
    ".simulation_content:not(.hidden) .simulation_box:not(.hidden)"
  ).attr("id");
  $("#" + target_page_id + " .chart_error_box").addClass("hidden");

  if (target_page_id == "simulation_tumitate_datas1") {
    graph_datas = simulation_tumitate_datas1(target_page_id);
  }

  if (target_page_id == "simulation_tumitate_datas2") {
    graph_datas = simulation_tumitate_datas2(target_page_id);
  }

  if (target_page_id == "simulation_tumitate_datas3") {
    graph_datas = simulation_tumitate_datas3(target_page_id);
  }

  if (target_page_id == "simulation_tumitate_datas4") {
    graph_datas = simulation_tumitate_datas4(target_page_id);
  }

  if (target_page_id == "simulation_toriguzusi_datas1") {
    graph_datas = simulation_toriguzusi_datas1(target_page_id);
  }
  if (target_page_id == "simulation_toriguzusi_datas2") {
    graph_datas = simulation_toriguzusi_datas2(target_page_id);
  }
  if (target_page_id == "simulation_toriguzusi_datas3") {
    graph_datas = simulation_toriguzusi_datas3(target_page_id);
  }
  if (target_page_id == "simulation_toriguzusi_datas4") {
    graph_datas = simulation_toriguzusi_datas4(target_page_id);
  }

  return graph_datas;
}

// 计算simulation 積み立て数据 目標リターンを計算する
// 参数 初期投資額
// 参数 毎月積立額
// 参数 投資期間
// 参数 目標金額
function simulation_tumitate_datas1(target_page_id) {
  let p_initial_holding_amount = getNumber(
    $("#" + target_page_id + " #initial_amount_input").attr("data-value"),
    10000
  ); //为0可以计算
  let p_monthly_reserve_amount = getNumber(
    $("#" + target_page_id + " #reserve_mount_input").attr("data-value"),
    10000
  );
  let p_operation_period = getNumber(
    $("#" + target_page_id + " #invest_period_input").attr("data-value"),
    1
  );
  let p_target_amount = getNumber(
    $("#" + target_page_id + " #target_amount_input").attr("data-value"),
    10000
  );
  if (
    p_monthly_reserve_amount == 0 ||
    p_operation_period == 0 ||
    p_target_amount == 0
  ) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_initial_holding_amount, 0, 50000000) == false) {
    console.log("初期投資額 Out of range");
    return [];
  }
  if (scope_judgment(p_monthly_reserve_amount, 5000, 1000000) == false) {
    console.log("毎月積立額 Out of range");
    return [];
  }
  if (scope_judgment(p_operation_period, 1, 50) == false) {
    console.log("投資期間 Out of range");
    return [];
  }
  if (scope_judgment(p_target_amount, 1000000, 200000000) == false) {
    console.log("目標金額 Out of range");
    return [];
  }

  let simulation_tumitate_datas2_list = [];
  // 第一 先找到1-②-2的年率 返回给 1-②-1再计算
  // 投資総額
  let toal_holding_amount =
    p_initial_holding_amount +
    p_monthly_reserve_amount * (p_operation_period * 12);
  // 通过 simulation_tumitate_datas2_2 的数组中 先拿到年率
  let datas2_year_rate = simulation_tumitate_datas1_2(
    p_initial_holding_amount,
    p_operation_period,
    p_monthly_reserve_amount
  );
  // 查找 datas2_year_rate 数组中 的最終運用額 小于等于目標金額
  // 返回对应的年率 默认为 0
  let search_year_rate = 0;
  if (toal_holding_amount < p_target_amount) {
    search_year_rate = search_match_value(
      datas2_year_rate,
      p_target_amount,
      5,
      0
    );
    if (typeof search_year_rate != "undefined") {
      // 更新比率到页面
      $("#" + target_page_id + " #content_text_1").html(
        (search_year_rate * 100).toFixed(2)
      );

      //计算 1-②-1
      let tmp_list = simulation_tumitate_datas1_3(
        p_initial_holding_amount,
        p_monthly_reserve_amount,
        search_year_rate,
        p_operation_period
      );
      // 只返回 月份 月末投資額 運用益累計
      for (let index = 0; index < tmp_list.length; index++) {
        simulation_tumitate_datas2_list.push([
          tmp_list[index][0],
          tmp_list[index][3],
          tmp_list[index][6],
        ]);
      }
    } else {
      $("#" + target_page_id + " #content_text_1").html("-");
      $("#" + target_page_id + " .chart_error_box")
        .html("目標金額達成に必要な利回りが高すぎます。設定を見直してください")
        .show();
    }
  } else {
    $("#" + target_page_id + " #content_text_1").html("0");
    $("#" + target_page_id + " .chart_error_box")
      .html("資産運用をせずに目標金額達成が可能です。設定を見直してください")
      .show();
  }
  return simulation_tumitate_datas2_list;
}

// 计算simulation 積み立て数据 目標リターンを計算する 的年率 先全部算出来 可能只需要返回一个年率
// 参数 初期投資額
// 参数 投資期間
// 参数 毎月積立額
function simulation_tumitate_datas1_2(
  p_initial_holding_amount,
  p_operation_period,
  p_monthly_reserve_amount
) {
  // 年率从0.001 到 1
  let start_year_rate = 1;
  let end_year_rate = 1000;
  let datas2_year_rate = [];
  let p_monthly_count = p_operation_period * 12;

  while (start_year_rate <= end_year_rate) {
    let year_rate = start_year_rate / 1000;
    let month_rate = Number(monthly_rate(year_rate).toFixed(18));
    // 年金終価係数
    let final_pension_price_coefficient = Number(
      ((Math.pow(1 + month_rate, p_monthly_count) - 1) / month_rate).toFixed(7)
    );
    // 積立部分
    let reserve_amount =
      final_pension_price_coefficient * p_monthly_reserve_amount;
    // 初期投資部分 $C$3*(1+G3)^$D$6
    let initial_holding = Number(
      (
        p_initial_holding_amount * Math.pow(1 + month_rate, p_monthly_count)
      ).toFixed(2)
    );
    // 最終運用額
    let end_Investment_profit = reserve_amount + initial_holding;

    start_year_rate = start_year_rate + 1;
    datas2_year_rate.push([
      year_rate,
      month_rate,
      final_pension_price_coefficient,
      reserve_amount,
      initial_holding,
      end_Investment_profit,
    ]);
  }
  return datas2_year_rate;
}

function simulation_tumitate_datas1_3(
  p_initial_holding_amount,
  p_monthly_reserve_amount,
  p_year_rate,
  p_operation_period
) {
  // 月期间
  let monthly_count = p_operation_period * 12;
  let current_monthly_Investment_profit_count = [];
  let datas = [];

  // 运用期间 1开始
  let interval = 1;
  while (interval <= monthly_count) {
    if (interval == 1) {
      // 月初投資額
      let monthly_initial_investment = p_initial_holding_amount;
      // 積立額
      let reserve_amount = p_monthly_reserve_amount;
      // 月末投資額
      let monthly_end_investment = monthly_initial_investment + reserve_amount;
      // 月初運用額
      let monthly_investment_amount = p_initial_holding_amount;
      // 当月運用益 显示用
      let current_monthly_Investment_profit = Math.round(
        monthly_rate(p_year_rate) * monthly_investment_amount
      );
      // 当月運用益 累加用
      current_monthly_Investment_profit_count.push(
        (monthly_rate(p_year_rate) * monthly_investment_amount).toFixed(5)
      );

      // 運用益累計
      let investment_profit_cumulative = current_monthly_Investment_profit;
      // 月末運用額
      let monthly_end_Investment_profit =
        monthly_end_investment + investment_profit_cumulative;

      datas.push([
        interval,
        monthly_initial_investment,
        reserve_amount,
        monthly_end_investment,
        monthly_investment_amount,
        current_monthly_Investment_profit,
        investment_profit_cumulative,
        monthly_end_Investment_profit,
      ]);
    } else {
      // 月初投資額
      let monthly_initial_investment = get_previous_self(interval, datas, 3);
      // 積立額
      let reserve_amount = get_current_self(interval, p_monthly_reserve_amount);
      // 月末投資額
      let monthly_end_investment = monthly_initial_investment + reserve_amount;
      // 月初運用額
      let monthly_investment_amount = get_previous_self(interval, datas, 7);
      // 当月運用益 显示用
      let current_monthly_Investment_profit = Math.round(
        monthly_rate(p_year_rate) * monthly_investment_amount
      );
      // 当月運用益 累加用
      current_monthly_Investment_profit_count.push(
        (monthly_rate(p_year_rate) * monthly_investment_amount).toFixed(5)
      );

      // 運用益累計
      let investment_profit_cumulative =
        current_monthly_Investment_profit + accumulation(datas, 5);
      // 月末運用額
      let monthly_end_Investment_profit =
        monthly_end_investment + investment_profit_cumulative;

      datas.push([
        interval,
        monthly_initial_investment,
        reserve_amount,
        monthly_end_investment,
        monthly_investment_amount,
        current_monthly_Investment_profit,
        investment_profit_cumulative,
        monthly_end_Investment_profit,
      ]);
    }

    interval = interval + 1;
  }
  return datas;
}

// 1-1 評価額を計算する 对应页面的最终金额计算
// 参数
// 初期投資額
// 毎月積立額
// リターン（年率）
// 投資期間

// simulation_tumitate_datas1(5000000,10000,0.01,50)
// 计算simulation 積み立て数据 評価額を計算する
// 该计算的 最終運用額 datas[datas.length][7]
function simulation_tumitate_datas2(target_page_id) {
  let p_initial_holding_amount = getNumber(
    $("#" + target_page_id + " #initial_amount_input").attr("data-value"),
    10000
  ); //为0可以计算
  let p_monthly_reserve_amount = getNumber(
    $("#" + target_page_id + " #reserve_mount_input").attr("data-value"),
    10000
  );
  let p_operation_period = getNumber(
    $("#" + target_page_id + " #invest_period_input").attr("data-value"),
    1
  );
  let p_year_rate = getNumber(
    $("#" + target_page_id + " #annual_rate_input").attr("data-value"),
    0.01
  );

  if (
    p_monthly_reserve_amount == 0 ||
    p_operation_period == 0 ||
    p_year_rate == 0
  ) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_initial_holding_amount, 0, 50000000) == false) {
    console.log("初期投資額 Out of range");
    return [];
  }
  if (scope_judgment(p_monthly_reserve_amount, 5000, 1000000) == false) {
    console.log("毎月積立額 Out of range");
    return [];
  }
  if (scope_judgment(p_operation_period, 1, 50) == false) {
    console.log("投資期間 Out of range");
    return [];
  }
  if (scope_judgment(p_year_rate, 0.001, 0.2) == false) {
    console.log("リターン（年率） Out of range");
    return [];
  }

  // 月期间
  let monthly_count = p_operation_period * 12;
  let current_monthly_Investment_profit_count = [];
  let datas = [];

  // 运用期间 1开始
  let interval = 1;
  let tmp_list = [];
  while (interval <= monthly_count) {
    if (interval == 1) {
      // 月初投資額
      let monthly_initial_investment = p_initial_holding_amount;
      // 積立額
      let reserve_amount = p_monthly_reserve_amount;
      // 月末投資額
      let monthly_end_investment = monthly_initial_investment + reserve_amount;
      // 月初運用額
      let monthly_investment_amount = p_initial_holding_amount;
      // 当月運用益 显示用
      let current_monthly_Investment_profit = Math.round(
        monthly_rate(p_year_rate) * monthly_investment_amount
      );
      // 当月運用益 累加用
      current_monthly_Investment_profit_count.push(
        (monthly_rate(p_year_rate) * monthly_investment_amount).toFixed(5)
      );

      // 運用益累計
      let investment_profit_cumulative = current_monthly_Investment_profit;
      // 月末運用額
      let monthly_end_Investment_profit =
        monthly_end_investment + investment_profit_cumulative;

      tmp_list.push([
        interval,
        monthly_initial_investment,
        reserve_amount,
        monthly_end_investment,
        monthly_investment_amount,
        current_monthly_Investment_profit,
        investment_profit_cumulative,
        monthly_end_Investment_profit,
      ]);
    } else {
      // 月初投資額
      let monthly_initial_investment = get_previous_self(interval, tmp_list, 3);
      // 積立額
      let reserve_amount = get_current_self(interval, p_monthly_reserve_amount);
      // 月末投資額
      let monthly_end_investment = monthly_initial_investment + reserve_amount;
      // 月初運用額
      let monthly_investment_amount = get_previous_self(interval, tmp_list, 7);
      // 当月運用益 显示用
      let current_monthly_Investment_profit = Math.round(
        monthly_rate(p_year_rate) * monthly_investment_amount
      );
      // 当月運用益 累加用
      current_monthly_Investment_profit_count.push(
        (monthly_rate(p_year_rate) * monthly_investment_amount).toFixed(5)
      );

      // 運用益累計
      let investment_profit_cumulative =
        current_monthly_Investment_profit + accumulation(tmp_list, 5);
      // 月末運用額
      let monthly_end_Investment_profit =
        monthly_end_investment + investment_profit_cumulative;

      tmp_list.push([
        interval,
        monthly_initial_investment,
        reserve_amount,
        monthly_end_investment,
        monthly_investment_amount,
        current_monthly_Investment_profit,
        investment_profit_cumulative,
        monthly_end_Investment_profit,
      ]);
    }

    interval = interval + 1;
  }

  // 只返回 月份 月末投資額 運用益累計
  for (let index = 0; index < tmp_list.length; index++) {
    datas.push([tmp_list[index][0], tmp_list[index][3], tmp_list[index][6]]);
  }
  // 更新比率到页面
  if (tmp_list[tmp_list.length - 1][7] < 999999999999) {
    $("#" + target_page_id + " #content_text_1").html(
      toThousands(Math.round(tmp_list[tmp_list.length - 1][7] / 10000))
    );
  } else {
    datas = [];
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html("資産運用をせずに目標金額達成が可能です。設定を見直してください")
      .show();
  }

  return datas;
}

// 计算simulation 積み立て数据 毎月積立額を計算する 1-④
// 参数 年率
// 参数 初期投資額
// 参数 投資期間
// 参数 目標金額
// 计算 毎月積立額
// 返回的二维数据
// 测试 simulation_tumitate_datas4(0.018, 10000000, 20, 50000000)
function simulation_tumitate_datas3(target_page_id) {
  let p_initial_holding_amount = getNumber(
    $("#" + target_page_id + " #initial_amount_input").attr("data-value"),
    10000
  ); //为0可以计算
  let year_rate = getNumber(
    $("#" + target_page_id + " #annual_rate_input").attr("data-value"),
    0.01
  );
  let p_investment_period = getNumber(
    $("#" + target_page_id + " #invest_period_input").attr("data-value"),
    1
  );
  let p_target_amount = getNumber(
    $("#" + target_page_id + " #target_amount_input").attr("data-value"),
    10000
  );

  if (p_investment_period == 0 || p_target_amount == 0 || year_rate == 0) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_initial_holding_amount, 0, 50000000) == false) {
    console.log("初期投資額 Out of range");
    return [];
  }
  if (scope_judgment(p_target_amount, 1000000, 200000000) == false) {
    console.log("目標金額 Out of range");
    return [];
  }
  if (scope_judgment(p_investment_period, 1, 50) == false) {
    console.log("投資期間 Out of range");
    return [];
  }
  if (scope_judgment(year_rate, 0.001, 0.2) == false) {
    console.log("リターン（年率） Out of range");
    return [];
  }

  // 初始数据
  let kikan = p_investment_period * 12;
  let count = 1;
  let datas = [];
  let tmp_datas = [];
  let m_rate = monthly_rate(year_rate);
  // 年金終価係数
  let final_pension_price_coefficient = Number(
    (Math.pow(1 + m_rate, kikan) - 1) / m_rate
  ).toFixed(12);

  // 初期投資部分
  let initial_investment = Math.round(
    p_initial_holding_amount * Math.pow(1 + m_rate, kikan)
  );
  // 毎月積立額（円単位）
  let amount_unit = 0;
  if (p_target_amount > p_initial_holding_amount) {
    amount_unit = roundup(
      (p_target_amount - initial_investment) / final_pension_price_coefficient,
      3
    );
  }

  while (count <= kikan) {
    let month_initial_investment;
    let month_end_amount;
    let monthly_nvestment_profit;
    let count_nvestment_profit;
    let current_nvestment_profit;
    let month_end_nvestment_profit;
    if (count == 1) {
      // 月初投資額
      month_initial_investment = p_initial_holding_amount;
      // 月末投資額
      month_end_amount = p_initial_holding_amount + amount_unit;
      // 月初運用額
      monthly_nvestment_profit = p_initial_holding_amount;
      // 当月運用益
      current_nvestment_profit = p_initial_holding_amount * m_rate;
      // 運用益累計
      count_nvestment_profit = current_nvestment_profit;
      // 月末運用額
      month_end_nvestment_profit = month_end_amount + count_nvestment_profit;
    } else {
      month_initial_investment = tmp_datas[tmp_datas.length - 1][3];
      month_end_amount = month_initial_investment + amount_unit;
      monthly_nvestment_profit = tmp_datas[tmp_datas.length - 1][7];
      current_nvestment_profit = monthly_nvestment_profit * m_rate;
      count_nvestment_profit =
        current_nvestment_profit + accumulation(tmp_datas, 5);
      month_end_nvestment_profit = month_end_amount + count_nvestment_profit;
    }

    tmp_datas.push([
      count,
      month_initial_investment,
      amount_unit,
      month_end_amount,
      monthly_nvestment_profit,
      current_nvestment_profit,
      count_nvestment_profit,
      month_end_nvestment_profit,
    ]);
    count = count + 1;
  }

  for (let index = 0; index < tmp_datas.length; index++) {
    datas.push([tmp_datas[index][0], tmp_datas[index][3], tmp_datas[index][6]]);
  }
  // 更新比率到页面

  if (p_target_amount > p_initial_holding_amount) {
    $("#" + target_page_id + " #content_text_1").html(
      toThousands(Math.round(amount_unit / 10000))
    );
  } else {
    datas = [];
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html("資産運用をせずに目標金額達成が可能です。設定を見直してください")
      .show();
  }

  if (amount_unit < 0) {
    datas = [];
    $("#" + target_page_id + " #content_text_1").html("0");
    $("#" + target_page_id + " .chart_error_box")
      .html("毎月の積立をせずに目標金額達成が可能です。設定を見直してください")
      .show();
  }

  return datas;
}

// 计算simulation 積み立て数据 投資期間を計算する 1-③-1
// 参数 年率
// 参数 初期投資額
// 参数 毎月積立額
// 参数 目標金額
// 返回的二维数据 一维数组里面index 3 和 6是画图用的
// 测试 simulation_tumitate_datas3(0.018, 40000000, 100000, 60000000)
function simulation_tumitate_datas4(target_page_id) {
  let p_initial_holding_amount = getNumber(
    $("#" + target_page_id + " #initial_amount_input").attr("data-value"),
    10000
  ); //为0可以计算
  let p_monthly_reserve_amount = getNumber(
    $("#" + target_page_id + " #reserve_mount_input").attr("data-value"),
    10000
  );
  let p_target_amount = getNumber(
    $("#" + target_page_id + " #target_amount_input").attr("data-value"),
    10000
  );
  let year_rate = getNumber(
    $("#" + target_page_id + " #annual_rate_input").attr("data-value"),
    0.01
  );

  if (p_monthly_reserve_amount == 0 || p_target_amount == 0 || year_rate == 0) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " #content_text_2").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_initial_holding_amount, 0, 50000000) == false) {
    console.log("初期投資額 Out of range");
    return [];
  }
  if (scope_judgment(p_monthly_reserve_amount, 5000, 1000000) == false) {
    console.log("毎月積立額 Out of range");
    return [];
  }
  if (scope_judgment(p_target_amount, 1000000, 200000000) == false) {
    console.log("目標金額 Out of range");
    return [];
  }
  if (scope_judgment(year_rate, 0.001, 0.2) == false) {
    console.log("リターン（年率） Out of range");
    return [];
  }

  let datas3 = [];
  let tmp_datas = [];
  // period 要计算数据的最大行数
  let target_period = simulation_tumitate_datas4_2(
    year_rate,
    p_initial_holding_amount,
    p_monthly_reserve_amount,
    p_target_amount
  );
  if (target_period != "NaN") {
    let count3 = 1;
    while (count3 <= target_period) {
      // 月初投資額
      let initial;
      // 積立額
      let amount;
      // 月末投資額
      let month_end_investment;
      // 月初運用額
      let investment_amount;
      // 当月運用益
      let current_month_profit;
      // 運用益累計
      let profit_count;
      // 月末運用額
      let month_end_amount;
      if (count3 == 1) {
        initial = p_initial_holding_amount;
        amount = p_monthly_reserve_amount;
        month_end_investment = initial + amount;
        investment_amount = p_initial_holding_amount;
        current_month_profit = Math.round(
          investment_amount * monthly_rate(year_rate)
        );
        profit_count = current_month_profit;
        month_end_amount = month_end_investment + profit_count;
      } else {
        initial = tmp_datas[tmp_datas.length - 1][3];
        amount = p_monthly_reserve_amount;
        month_end_investment = initial + amount;
        investment_amount = tmp_datas[tmp_datas.length - 1][7];
        current_month_profit = Math.round(
          investment_amount * monthly_rate(year_rate)
        );
        profit_count = current_month_profit + accumulation(tmp_datas, 5);
        month_end_amount = month_end_investment + profit_count;
      }

      tmp_datas.push([
        count3,
        initial,
        amount,
        month_end_investment,
        investment_amount,
        current_month_profit,
        profit_count,
        month_end_amount,
      ]);
      count3 = count3 + 1;
    }

    for (let index = 0; index < tmp_datas.length; index++) {
      datas3.push([
        tmp_datas[index][0],
        tmp_datas[index][3],
        tmp_datas[index][6],
      ]);
    }

    $("#" + target_page_id + " #content_text_1").html(
      parseInt(target_period / 12)
    );
    $("#" + target_page_id + " #content_text_2").html(target_period % 12);
  } else {
    datas3 = [];
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " #content_text_2").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html("目標金額達成に必要な期間が長すぎます。設定を見直してください")
      .show();
  }

  if (p_target_amount <= p_initial_holding_amount) {
    datas3 = [];
    $("#" + target_page_id + " #content_text_1").html("0");
    $("#" + target_page_id + " #content_text_2").html("1");
    $("#" + target_page_id + " .chart_error_box")
      .html("資産運用をせずに目標金額達成が可能です。設定を見直してください")
      .show();
  }

  return datas3;
}

// 目的 计算1-③-2的投资期间
// 参数 年率
// 参数 初期投資額
// 参数 毎月積立額
// 参数 目標金額
// 测试 simulation_tumitate_datas4_2(0.018, 40000000, 100000, 60000000)
function simulation_tumitate_datas4_2(
  year_rate,
  p_initial_holding_amount,
  p_monthly_reserve_amount,
  p_target_amount
) {
  let m_rate = monthly_rate(year_rate);
  // 現状の範囲は1か月～1000か月
  let count = 1;
  let tmp_datas = [];

  // 返回数据 投資期間
  let period = "NaN";
  while (count <= 1000) {
    let year = Math.round(count / 12);
    let year_coefficient = Number((Math.pow(1 + m_rate, count) - 1) / m_rate);
    let amount = year_coefficient * p_monthly_reserve_amount;
    let initial =
      p_initial_holding_amount * Number(Math.pow(1 + m_rate, count));
    let finally_investment_amount = Math.round(amount + initial);
    tmp_datas.push([
      count,
      year,
      year_coefficient,
      amount,
      initial,
      finally_investment_amount,
    ]);
    count = count + 1;
  }

  // 生成好数据在计算 投資期間 月份单位
  if (p_target_amount >= p_initial_holding_amount) {
    for (let index = 0; index < tmp_datas.length; index++) {
      if (p_target_amount <= tmp_datas[index][5]) {
        period = tmp_datas[index][0];
        break;
      }
    }
  }
  return period;
}

// ######################################### 分割线 #########################################

// redmine 9325 2 取り崩し 2-②-1
// 毎月取り崩し額  投資元本を計算する
// 参数:
// 投資元本
// 毎月取崩額
// 投資期間
// 测试 simulation_toriguzusi_datas2_2_1(50000000, 200000, 30)
function simulation_toriguzusi_datas1(target_page_id) {
  let p_investment_principal = getNumber(
    $("#" + target_page_id + " #assets_amount_input").attr("data-value"),
    10000
  );
  let p_monthly_withdrawal_amount = getNumber(
    $("#" + target_page_id + " #withdrawal_amount_input").attr("data-value"),
    10000
  );
  let p_investment_period = getNumber(
    $("#" + target_page_id + " #withdrawal_period_input").attr("data-value"),
    1
  );
  if (
    p_investment_principal == 0 ||
    p_monthly_withdrawal_amount == 0 ||
    p_investment_period == 0
  ) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_investment_principal, 0, 999999999999) == false) {
    console.log("投資元本 Out of range");
    return [];
  }
  if (scope_judgment(p_monthly_withdrawal_amount, 5000, 1000000) == false) {
    console.log("毎月積立額 Out of range");
    return [];
  }
  if (scope_judgment(p_investment_period, 1, 50) == false) {
    console.log("投資期間 Out of range");
    return [];
  }

  let count2 = 1;
  let datas2 = [];
  let tmp_datas = [];
  let monthly_count = p_investment_period * 12;
  let target_year_rate = simulation_toriguzusi_datas1_2(
    p_investment_principal,
    p_monthly_withdrawal_amount,
    p_investment_period
  );
  if (target_year_rate == "NaN") {
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html(
        "取り崩しを続けるのに必要な利回りが高すぎます。設定を見直してください"
      )
      .show();
  } else {
    let m_rate = monthly_rate(target_year_rate);

    while (count2 <= monthly_count) {
      // 月初投資額
      let month_initial_investment;
      // 月末投資額
      let month_end_amount;
      // 月末運用額
      let month_end_nvestment_profit;
      // 運用益累計
      let count_nvestment_profit;
      let graph_nvestment_profit;
      // 月初運用額
      let monthly_nvestment_profit;
      // 当月運用益
      let current_nvestment_profit;
      let graph_investment_principal;
      if (count2 == 1) {
        month_initial_investment = p_investment_principal;
        month_end_amount =
          month_initial_investment - p_monthly_withdrawal_amount;
        monthly_nvestment_profit = p_investment_principal;
        current_nvestment_profit = monthly_nvestment_profit * m_rate;
        count_nvestment_profit = current_nvestment_profit;
        month_end_nvestment_profit = month_end_amount + count_nvestment_profit;
      } else {
        month_initial_investment = tmp_datas[tmp_datas.length - 1][3];
        month_end_amount =
          month_initial_investment - p_monthly_withdrawal_amount;
        monthly_nvestment_profit = tmp_datas[tmp_datas.length - 1][7];
        current_nvestment_profit = monthly_nvestment_profit * m_rate;
        count_nvestment_profit =
          current_nvestment_profit + accumulation(tmp_datas, 5);
        month_end_nvestment_profit = month_end_amount + count_nvestment_profit;
      }

      if (month_end_amount > 0) {
        graph_investment_principal = month_end_amount;
      } else {
        graph_investment_principal = 0;
      }

      if (month_end_amount > 0) {
        graph_nvestment_profit = count_nvestment_profit;
      } else {
        graph_nvestment_profit = month_end_amount + count_nvestment_profit;
      }

      tmp_datas.push([
        count2,
        month_initial_investment,
        -p_monthly_withdrawal_amount,
        month_end_amount,
        monthly_nvestment_profit,
        current_nvestment_profit,
        count_nvestment_profit,
        month_end_nvestment_profit,
        graph_investment_principal,
        graph_nvestment_profit,
      ]);
      count2 = count2 + 1;
    }

    for (let index = 0; index < tmp_datas.length; index++) {
      datas2.push([
        tmp_datas[index][0],
        tmp_datas[index][8],
        tmp_datas[index][9],
      ]);
    }

    //投資元本より取り崩し総額が小さい
    if (
      tmp_datas[tmp_datas.length - 1][0] * tmp_datas[tmp_datas.length - 1][2] +
        p_investment_principal >
      0
    ) {
      datas2 = [];
      $("#" + target_page_id + " #content_text_1").html("-");
      $("#" + target_page_id + " .chart_error_box")
        .html("資産運用をせずに取り崩しが可能です。設定を見直してください")
        .show();
    } else {
      $("#" + target_page_id + " #content_text_1").html(
        (target_year_rate * 100).toFixed(2)
      );
    }
  }

  return datas2;
}

// redmine 9325 2 取り崩し 2-②-2
// 毎月取り崩し額  计算 リターン（年率）
// 参数:
// 投資元本
// 毎月取崩額
// 投資期間
// 返回 リターン（年率）
// 测试 simulation_toriguzusi_datas1_2(50000000, 200000, 30)
function simulation_toriguzusi_datas1_2(
  p_investment_principal,
  p_monthly_withdrawal_amount,
  p_investment_period
) {
  // 現状の範囲は0.1%～100%
  let count = 1;
  let datas = [];
  let monthly_count = p_investment_period * 12;
  let target_year_rate = "NaN";

  while (count <= 1000) {
    let year_rate = count / 1000;
    let m_rate = monthly_rate(year_rate);
    // 資本回収係数
    let capital_recovery_coefficient = Number(
      m_rate / (1 - Math.pow(1 + m_rate, -monthly_count))
    );
    // 毎月取崩額
    let withdrawal_amount = p_monthly_withdrawal_amount;
    // 必要元本
    let required_principal = withdrawal_amount / capital_recovery_coefficient;
    datas.push([
      year_rate,
      m_rate,
      capital_recovery_coefficient,
      withdrawal_amount,
      required_principal,
    ]);
    count = count + 1;
  }
  // 然后在datas二维数组中找
  // 投資元本 >= 必要元本 那一列的 リターン（年率）
  for (let index = 0; index < datas.length; index++) {
    if (p_investment_principal >= datas[index][4]) {
      target_year_rate = datas[index][0];
      break;
    }
  }
  return target_year_rate;
}

// 返回 運用期間 2-④
// 参数:
// 投資元本
// 投資期間
// リターン（年率）
// simulation_toriguzusi_datas2(8000000, 10, 0.02)
function simulation_toriguzusi_datas2(target_page_id) {
  let p_investment_principal = getNumber(
    $("#" + target_page_id + " #assets_amount_input").attr("data-value"),
    10000
  );
  let p_investment_period = getNumber(
    $("#" + target_page_id + " #withdrawal_period_input").attr("data-value"),
    1
  );
  let p_year_rate = getNumber(
    $("#" + target_page_id + " #annual_rate_input").attr("data-value"),
    0.01
  );

  if (
    p_investment_principal == 0 ||
    p_investment_period == 0 ||
    p_year_rate == 0
  ) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_investment_principal, 0, 999999999999) == false) {
    console.log("投資元本 Out of range");
    return [];
  }
  if (scope_judgment(p_investment_period, 1, 50) == false) {
    console.log("投資期間 Out of range");
    return [];
  }
  if (scope_judgment(p_year_rate, 0.001, 0.2) == false) {
    console.log("リターン（年率） Out of range");
    return [];
  }

  let m_rate = monthly_rate(p_year_rate);
  let monthly_count = p_investment_period * 12;
  // 資本回収係数
  let capital_recovery_coefficient = Number(
    m_rate / (1 - Math.pow(1 + m_rate, -monthly_count))
  );
  // 取崩額
  let p_monthly_withdrawal_amount =
    p_investment_principal * capital_recovery_coefficient;
  let count = 1;
  let datas = [];
  let tmp_datas = [];

  while (count <= monthly_count) {
    // 月初投資額
    let month_initial_investment;
    // 月末投資額
    let month_end_amount;
    // 当月運用益
    let current_nvestment_profit;
    // 月末運用額
    let month_end_nvestment_profit;
    // 月初運用額
    let monthly_nvestment_profit;
    // 運用益累計
    let count_nvestment_profit;
    let graph_investment_principal;
    let graph_nvestment_profit;
    if (count == 1) {
      month_initial_investment = p_investment_principal;
      month_end_amount = month_initial_investment - p_monthly_withdrawal_amount;
      monthly_nvestment_profit = p_investment_principal;
      current_nvestment_profit = monthly_nvestment_profit * m_rate;
      count_nvestment_profit = current_nvestment_profit;
      month_end_nvestment_profit = month_end_amount + count_nvestment_profit;
    } else {
      month_initial_investment = tmp_datas[tmp_datas.length - 1][3];
      month_end_amount = month_initial_investment - p_monthly_withdrawal_amount;
      monthly_nvestment_profit = tmp_datas[tmp_datas.length - 1][7];
      current_nvestment_profit = monthly_nvestment_profit * m_rate;
      count_nvestment_profit =
        current_nvestment_profit + accumulation(tmp_datas, 5);
      month_end_nvestment_profit = Math.round(
        month_end_amount + count_nvestment_profit
      );
    }

    if (month_end_amount > 0) {
      graph_investment_principal = month_end_amount;
    } else {
      graph_investment_principal = 0;
    }

    if (month_end_amount > 0) {
      graph_nvestment_profit = count_nvestment_profit;
    } else {
      graph_nvestment_profit = Math.round(
        month_end_amount + count_nvestment_profit
      );
    }

    tmp_datas.push([
      count,
      month_initial_investment,
      -p_monthly_withdrawal_amount,
      month_end_amount,
      monthly_nvestment_profit,
      current_nvestment_profit,
      count_nvestment_profit,
      month_end_nvestment_profit,
      graph_investment_principal,
      graph_nvestment_profit,
    ]);

    count = count + 1;
  }

  for (let index = 0; index < tmp_datas.length; index++) {
    datas.push([tmp_datas[index][0], tmp_datas[index][8], tmp_datas[index][9]]);
  }

  //投資元本より取り崩し総額が小さい
  if (
    tmp_datas[tmp_datas.length - 1][0] * tmp_datas[tmp_datas.length - 1][2] +
      p_investment_principal >
    0
  ) {
    datas = [];
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html("取り崩しの計算ができません。設定を見直してください")
      .show();
  } else {
    $("#" + target_page_id + " #content_text_1").html(
      toThousands(Math.round(p_monthly_withdrawal_amount / 10000))
    );
    if (Math.round(p_monthly_withdrawal_amount / 10000) < 1) {
      datas = [];
      $("#" + target_page_id + " .chart_error_box")
        .html(
          "取り崩し金額が1万円未満の為表示できません。設定を見直してください"
        )
        .show();
    }
  }

  return datas;
}

// redmine 9325 2 取り崩し 2-③-1
// 毎月取り崩し額  運用期間を計算する
// 参数:
// 投資元本
// 毎月取崩額
// リターン（年率）
// simulation_toriguzusi_datas3(30000000, 90000, 0.01)
function simulation_toriguzusi_datas3(target_page_id) {
  let p_investment_principal = getNumber(
    $("#" + target_page_id + " #assets_amount_input").attr("data-value"),
    10000
  );
  let p_monthly_withdrawal_amount = getNumber(
    $("#" + target_page_id + " #withdrawal_amount_input").attr("data-value"),
    10000
  );
  let p_year_rate = getNumber(
    $("#" + target_page_id + " #annual_rate_input").attr("data-value"),
    0.01
  );

  if (
    p_investment_principal == 0 ||
    p_monthly_withdrawal_amount == 0 ||
    p_year_rate == 0
  ) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " #content_text_2").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_investment_principal, 0, 999999999999) == false) {
    console.log("投資元本 Out of range");
    return [];
  }
  if (scope_judgment(p_monthly_withdrawal_amount, 5000, 1000000) == false) {
    console.log("毎月取崩額 Out of range");
    return [];
  }
  if (scope_judgment(p_year_rate, 0.001, 0.2) == false) {
    console.log("リターン（年率） Out of range");
    return [];
  }

  let count = 1;
  let datas = [];
  let tmp_datas = [];
  let m_rate = monthly_rate(p_year_rate);
  let rows = simulation_toriguzusi_datas3_1(
    p_investment_principal,
    p_monthly_withdrawal_amount,
    p_year_rate
  );
  if (rows != "NaN") {
    // 資本回収係数
    // let capital_recovery_coefficient = Number(
    //   m_rate / (1 - Math.pow(1 + m_rate, -rows))
    // )

    while (count <= rows) {
      // 月初投資額
      let month_initial_investment;
      // 月末投資額
      let month_end_amount;
      // 当月運用益
      let current_nvestment_profit;
      // 運用益累計
      let count_nvestment_profit;
      // 月初運用額
      let monthly_nvestment_profit;
      // 月末運用額
      let month_end_nvestment_profit;
      let graph_investment_principal;
      let graph_nvestment_profit;
      if (count == 1) {
        month_initial_investment = p_investment_principal;
        month_end_amount =
          month_initial_investment - p_monthly_withdrawal_amount;
        monthly_nvestment_profit = p_investment_principal;
        current_nvestment_profit = monthly_nvestment_profit * m_rate;
        count_nvestment_profit = current_nvestment_profit;
        month_end_nvestment_profit = month_end_amount + count_nvestment_profit;
      } else {
        month_initial_investment = tmp_datas[tmp_datas.length - 1][3];
        month_end_amount =
          month_initial_investment - p_monthly_withdrawal_amount;
        monthly_nvestment_profit = tmp_datas[tmp_datas.length - 1][7];
        current_nvestment_profit = monthly_nvestment_profit * m_rate;
        count_nvestment_profit =
          current_nvestment_profit + accumulation(tmp_datas, 5);
        month_end_nvestment_profit = month_end_amount + count_nvestment_profit;
      }

      if (month_end_amount > 0) {
        graph_investment_principal = month_end_amount;
      } else {
        graph_investment_principal = 0;
      }

      if (month_end_amount > 0) {
        graph_nvestment_profit = count_nvestment_profit;
      } else {
        graph_nvestment_profit = month_end_amount + count_nvestment_profit;
      }

      tmp_datas.push([
        count,
        month_initial_investment,
        -p_monthly_withdrawal_amount,
        month_end_amount,
        monthly_nvestment_profit,
        current_nvestment_profit,
        count_nvestment_profit,
        month_end_nvestment_profit,
        graph_investment_principal,
        graph_nvestment_profit,
      ]);
      count = count + 1;
    }

    for (let index = 0; index < tmp_datas.length; index++) {
      datas.push([
        tmp_datas[index][0],
        tmp_datas[index][8],
        tmp_datas[index][9],
      ]);
    }

    // 更新比率到页面
    $("#" + target_page_id + " #content_text_1").html(parseInt(rows / 12));
    $("#" + target_page_id + " #content_text_2").html(rows % 12);

    if (parseInt(rows / 12) == 0) {
      datas = [];
      $("#" + target_page_id + " .chart_error_box")
        .html("取り崩し期間が1年未満の為表示できません。設定を見直してください")
        .show();
    }

    //投資元本より取り崩し総額が小さい
    if (
      tmp_datas[tmp_datas.length - 1][0] * tmp_datas[tmp_datas.length - 1][2] +
        p_investment_principal >
      0
    ) {
      datas = [];
      $("#" + target_page_id + " #content_text_1").html("-");
      $("#" + target_page_id + " #content_text_2").html("-");
      $("#" + target_page_id + " .chart_error_box")
        .html("取り崩しの計算ができません。設定を見直してください")
        .show();
    }
  } else {
    datas = [];
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " #content_text_2").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html("取り崩し可能な期間が長すぎます。設定を見直してください")
      .show();
  }
  return datas;
}

// 返回 運用期間 2-③-2
// 現状の範囲は1か月～1000か月
// 参数:
// 投資元本
// 毎月取崩額
// リターン（年率）
// simulation_toriguzusi_datas2_3_2(30000000, 90000, 0.01)
function simulation_toriguzusi_datas3_1(
  p_investment_principal,
  p_monthly_withdrawal_amount,
  p_year_rate
) {
  let m_rate = monthly_rate(p_year_rate);
  let step = 1;
  let tmp_datas = [];
  let monthly_rows = "NaN";

  while (step <= 1000) {
    let year = Math.round(step / 12);
    // 資本回収係数
    let capital_recovery_coefficient = Number(
      m_rate / (1 - Math.pow(1 + m_rate, -step))
    );
    // 毎月取崩額
    let withdrawal_amount = p_monthly_withdrawal_amount;
    // 必要元本
    let required_principal = withdrawal_amount / capital_recovery_coefficient;

    tmp_datas.push([
      step,
      year,
      capital_recovery_coefficient,
      withdrawal_amount,
      required_principal,
    ]);
    step = step + 1;
  }

  // 投資元本 不能大于 必要元本 看excel的 2-③-2
  if (p_investment_principal > tmp_datas[tmp_datas.length - 1][4]) {
    console.log("限界超えてます");
    return monthly_rows;
  }

  // 模糊匹配到 取绝对值
  for (let index = 1; index < tmp_datas.length; index++) {
    if (p_investment_principal < tmp_datas[index][4]) {
      let current_absolute = Math.abs(
        p_investment_principal - tmp_datas[index][4]
      );
      let previous_absolute = Math.abs(
        p_investment_principal - tmp_datas[index - 1][4]
      );

      if (current_absolute < previous_absolute) {
        monthly_rows = tmp_datas[index][0];
      } else {
        monthly_rows = tmp_datas[index - 1][0];
      }
      break;
    }
  }
  return monthly_rows;
}

// redmine 9325 2 取り崩し 2-①
// 毎月取り崩し額  计算 金融資産額:投資元本
// 参数:
// 年率リターン
// 毎月取り崩し額
// 投資期間
// simulation_toriguzusi_datas4(0.04, 120000, 30)
function simulation_toriguzusi_datas4(target_page_id) {
  let p_monthly_withdrawal_amount = getNumber(
    $("#" + target_page_id + " #withdrawal_amount_input").attr("data-value"),
    10000
  );
  let p_investment_period = getNumber(
    $("#" + target_page_id + " #withdrawal_period_input").attr("data-value"),
    1
  );
  let p_year_rate = getNumber(
    $("#" + target_page_id + " #annual_rate_input").attr("data-value"),
    0.01
  );

  if (
    p_investment_period == 0 ||
    p_monthly_withdrawal_amount == 0 ||
    p_year_rate == 0
  ) {
    console.log("input val is null");
    $("#" + target_page_id + " #content_text_1").html("-");
    return [];
  }

  // 判断页面拿到的值是否在范围内
  if (scope_judgment(p_monthly_withdrawal_amount, 5000, 1000000) == false) {
    console.log("毎月取り崩し額 Out of range");
    return [];
  }
  if (scope_judgment(p_investment_period, 1, 50) == false) {
    console.log("投資期間 Out of range");
    return [];
  }
  if (scope_judgment(p_year_rate, 0.001, 0.2) == false) {
    console.log("リターン（年率） Out of range");
    return [];
  }

  // 循环次数为 monthly_count
  let monthly_count = p_investment_period * 12;

  let m_rate = monthly_rate(p_year_rate);
  // 資本回収係数
  let capital_recovery_coefficient = Number(
    m_rate / (1 - Math.pow(1 + m_rate, -monthly_count))
  );
  // 投資元本 初始值
  let investment_principal =
    p_monthly_withdrawal_amount / capital_recovery_coefficient;

  let count = 1;
  let datas = [];
  let tmp_datas = [];
  while (count <= monthly_count) {
    // 月末運用額
    let month_end_nvestment_profit;
    // 月初運用額
    let monthly_nvestment_profit;
    // 運用益累計
    let count_nvestment_profit;
    // 当月運用益
    let current_nvestment_profit;
    // 月初投資額
    let month_initial_investment;
    // 月末投資額
    let month_end_amount;
    let graph_nvestment_profit;
    let graph_investment_principal;
    if (count == 1) {
      month_initial_investment = investment_principal;
      month_end_amount = month_initial_investment - p_monthly_withdrawal_amount;
      monthly_nvestment_profit = month_initial_investment;
      current_nvestment_profit = monthly_nvestment_profit * m_rate;
      count_nvestment_profit = current_nvestment_profit;
      month_end_nvestment_profit = Math.round(
        month_end_amount + count_nvestment_profit
      );
    } else {
      month_initial_investment = tmp_datas[tmp_datas.length - 1][3];
      month_end_amount = month_initial_investment - p_monthly_withdrawal_amount;
      monthly_nvestment_profit = tmp_datas[tmp_datas.length - 1][7];
      current_nvestment_profit = monthly_nvestment_profit * m_rate;
      count_nvestment_profit =
        current_nvestment_profit + accumulation(tmp_datas, 5);
      month_end_nvestment_profit = Math.round(
        month_end_amount + count_nvestment_profit
      );
    }

    if (month_end_amount > 0) {
      graph_investment_principal = month_end_amount;
    } else {
      graph_investment_principal = 0;
    }

    if (month_end_amount > 0) {
      graph_nvestment_profit = count_nvestment_profit;
    } else {
      graph_nvestment_profit = month_end_amount + count_nvestment_profit;
    }

    tmp_datas.push([
      count,
      month_initial_investment,
      -p_monthly_withdrawal_amount,
      month_end_amount,
      monthly_nvestment_profit,
      current_nvestment_profit,
      count_nvestment_profit,
      month_end_nvestment_profit,
      graph_investment_principal,
      graph_nvestment_profit,
    ]);

    count = count + 1;
  }

  for (let index = 0; index < tmp_datas.length; index++) {
    datas.push([tmp_datas[index][0], tmp_datas[index][8], tmp_datas[index][9]]);
  }

  // 更新比率到页面
  if (tmp_datas[0][1] < 999999999999) {
    $("#" + target_page_id + " #content_text_1").html(
      toThousands(Math.round(tmp_datas[0][1] / 10000))
    );
  } else {
    datas = [];
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html("必要な金額が高額すぎます。設定を見直してください")
      .show();
  }

  //投資元本より取り崩し総額が小さい
  if (
    tmp_datas[tmp_datas.length - 1][0] * tmp_datas[tmp_datas.length - 1][2] +
      tmp_datas[0][1] >
    0
  ) {
    datas = [];
    $("#" + target_page_id + " #content_text_1").html("-");
    $("#" + target_page_id + " #content_text_2").html("-");
    $("#" + target_page_id + " .chart_error_box")
      .html("取り崩しの計算ができません。設定を見直してください")
      .show();
  }

  return datas;
}

// 查找数据对应值
// 参数 二维数组 要比较的值 数据的index 要返回数据的哪一列
function search_match_value(arrs, source_value, index, return_index) {
  let child_arrs = arrs.map(function (value) {
    return value[index];
  });
  for (let index = 0; index < child_arrs.length; index++) {
    let element = child_arrs[index];
    if (element >= source_value) {
      return arrs[index][return_index];
    }
  }
}

// 返回上个数据同列的值
function get_previous_self(interval, results, index) {
  if (interval > 0) {
    return results[results.length - 1][index];
  } else {
    return 0;
  }
}

// 返回当前自己
function get_current_self(interval, data) {
  if (interval > 0) {
    return data;
  } else {
    return 0;
  }
}

// 月率リターン 计算
function monthly_rate(year_rate) {
  // 年率リターン
  return Math.pow(1 + year_rate, 1 / 12) - 1;
}

// 二维数组累加计算
function accumulation(source_ary, target_index) {
  let target_ary = [];
  for (let index = 0; index < source_ary.length; index++) {
    target_ary.push(source_ary[index][target_index]);
  }
  let sum = target_ary.reduce((x, y) => x + y);
  return sum;
}

// 超出范围返回false
function scope_judgment(val, mincal, maxval) {
  if (mincal <= val && val <= maxval) {
    return true;
  } else {
    return false;
  }
}

function roundup(num, per) {
  let precision = Math.pow(10, per);
  return Math.ceil(num / precision) * precision;
}

function toThousands(num, n) {
  if (num == null || num == "num") {
    return "-";
  }
  let plus = num.toString().indexOf("+") != -1 ? "+" : "";
  num = num.toString().indexOf("+") != -1 ? num.toString().split("+")[1] : num;
  let leftNum =
    num.toString().indexOf(".") != -1 ? num.toString().split(".")[0] : num;
  let rightStr = "";
  let tmpNum = num.toString();
  if (n >= 0) {
    tmpNum = parseFloat(num).myRound(n);
  }
  let rightNum = tmpNum.toString().split(".")[1];
  if (tmpNum > 0 && tmpNum.toString().split(".")[0] > parseInt(leftNum)) {
    leftNum = (parseInt(leftNum) + 1).toString();
  } else if (
    tmpNum < 0 &&
    tmpNum.toString().split(".")[0] < parseInt(leftNum)
  ) {
    leftNum = (parseInt(leftNum) - 1).toString();
  }

  let leftStr = leftNum.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");

  if (rightNum) {
    rightStr = "." + rightNum;
  }

  if (plus + leftStr + rightStr == "-0") return "0";

  return plus + leftStr + rightStr;
}

function inputValToThousand(
  val,
  maxlength,
  autoNum,
  keyupType,
  floatType,
  negativeFlag,
  decimal
) {
  if (autoNum == null) autoNum = 0;
  if (keyupType == null) keyupType = true;
  if (floatType == null) floatType = true;
  if (negativeFlag == null) negativeFlag = false;
  if (decimal == null) decimal = 2;

  autoNum += 1;
  var valNum = "";
  var valThousands = "";
  var reg = "0-9";
  if (floatType) {
    reg += ".";
  }
  if (negativeFlag) {
    reg += "-";
  }
  var arr = val.match(new RegExp("[" + reg + "]", "g"));
  if (arr) {
    // console.log("arr.length:" + arr.length);
    if (arr.length == 1) {
      if (arr[0] == ".") {
      } else if (keyupType && arr[0] == "-") {
        valThousands = "-";
      } else {
        valNum = arr[0];
        valThousands = arr[0];
      }
    } else {
      var newArr = [];
      $.extend(newArr, arr);
      var lastVal = arr[arr.length - 1];
      if (lastVal == "-" || lastVal == ".") {
        newArr.pop();
      }
      var tmpStr = newArr.join("");
      // console.log("tmpStr: " + tmpStr);
      valNum = parseFloat(tmpStr);
      // console.log("valNum: " + valNum);
      valThousands = toThousands(valNum, decimal);
      // console.log("==:" + val.indexOf(".") == -1);
      if (keyupType && newArr.indexOf(".") == -1 && lastVal == ".") {
        valThousands += ".";
      } else if (
        keyupType &&
        tmpStr.substring(tmpStr.length - 2, tmpStr.length) == ".0"
      ) {
        // input 10.0 => 10 error
        valThousands += ".0";
      }
    }
  }
  // console.log("valNum:" + valNum + "  valThousands: " + valThousands)
  var errorMaxNum = 10;
  if (autoNum <= errorMaxNum && valThousands.length > maxlength) {
    var newVal = valThousands.substr(0, maxlength);
    // console.log(newVal.length + "  newVal1111:" + newVal);

    var arr = inputValToThousand(
      newVal,
      maxlength,
      autoNum,
      keyupType,
      floatType,
      negativeFlag,
      decimal
    );
    if (autoNum == errorMaxNum)
      console.log(maxlength + " - error autoNum:" + autoNum);
    if (autoNum < errorMaxNum && arr[1].length < maxlength) {
      var maxlengthVal = valThousands[maxlength];
      // console.log("maxlengthVal:" + maxlengthVal);
      newVal = arr[1] + maxlengthVal;
      arr = inputValToThousand(
        newVal,
        maxlength,
        autoNum,
        keyupType,
        floatType,
        negativeFlag,
        decimal
      );
    }
    return arr;
  }
  // console.log("valNum33333:" + valNum + "  valThousands: " + valThousands)
  return [valNum, valThousands];
}

Number.prototype.myRound = function (n) {
  n = n > 0 && n <= 20 ? n : 0;

  var tmp = new Decimal(Number(this))
    .mul(new Decimal(Math.pow(10, n)))
    .toNumber();
  return new Decimal(tmp)
    .round()
    .div(new Decimal(Math.pow(10, n)))
    .toNumber();
};
